import type { TwiageCase } from "@/App/types/TwiageCase";
import { CadNames } from "@/App/components/Cad/types/CadNames";

export const isMihCompletedCase = (twiageCase: TwiageCase): boolean => {
  return (
    twiageCase.cadStatus === CadNames.jobFinished ||
    twiageCase.cadStatus === CadNames.released ||
    twiageCase.cadStatus === CadNames.treatedAndReleased ||
    twiageCase.mih?.canceled !== undefined
  );
};
